import React from "react"

interface FairsAppProps {}

export const FairsApp: React.FC<FairsAppProps> = ({ children }) => {
  return <>{children}</>
}
